module.exports = __webpack_public_path__ + "static/media/ogrodzenie_panelowe_przetlaczane.450374af.pdf";